import "core-js/modules/es.array.fill.js";
var baseSize = 24; // Базовый размер иконки в пикселях

export var iconPortalTokens = {
  sizes: {
    xxxl: baseSize * 2,
    // 48
    xxl: baseSize * 1.75,
    // 42
    xl: baseSize * 1.5,
    // 36
    l: baseSize * 1.25,
    // 30
    m: baseSize,
    // 24
    s: baseSize * 0.75,
    // 18
    xs: baseSize * 0.5 // 12

  },
  button: {
    defaultVariant: "neutral",
    variants: {
      primary: {
        base: function base(_ref) {
          var color = _ref.color;
          return color.importance.primary.base;
        },
        hover: function hover(_ref2) {
          var color = _ref2.color;
          return color.importance.primary.active;
        }
      },
      neutral: {
        base: function base(_ref3) {
          var color = _ref3.color;
          return color.fill.icon.base;
        },
        hover: function hover(_ref4) {
          var color = _ref4.color;
          return color.fill.icon.hover;
        }
      }
    },
    focus: {
      color: function color(_ref5) {
        var _color = _ref5.color;
        return _color.border.focus.base;
      },
      params: "0 0 3px 1px"
    }
  }
};